 /**
   * Extracts all available device/browser info silently.
   * Returns a JavaScript object (ready to be JSON.stringify'd).
   */
  export default function getDeviceFingerprint() {
    // Helper to get GPU Info (WebGL)
    const getGPUInfo = () => {
      try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) return 'WebGL Unavailable';
        
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        return debugInfo 
          ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) 
          : 'Unknown GPU';
      } catch (e) {
        return 'Error detecting GPU';
      }
    };

    // Helper to get Connection Info (Chrome/Edge only)
    const getConnectionInfo = () => {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return connection ? connection.effectiveType : 'Unknown/Hidden';
    };

    return {
      // Browser & OS
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      cookiesEnabled: navigator.cookieEnabled,
      
      // Screen & Window
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      pixelRatio: window.devicePixelRatio,
      orientation: window.screen.orientation ? window.screen.orientation.type : 'unknown',

      // Hardware
      cpuCores: navigator.hardwareConcurrency || 'Unknown',
      ram: navigator.deviceMemory ? `~${navigator.deviceMemory} GB` : 'Unknown (API restricted)',
      gpu: getGPUInfo(),
      touchPoints: navigator.maxTouchPoints,

      // Context
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      onlineStatus: navigator.onLine ? 'Online' : 'Offline',
      referrer: document.referrer || 'Direct Visit',
      connectionType: getConnectionInfo(),
      timestamp: new Date().toISOString()
    };
  };